
import * as quicklink from "quicklink";
//import * as $ from "jquery";
import "waypoints/lib/jquery.waypoints.js";
import "waypoints/lib/shortcuts/inview.js";
import "waypoints/lib/shortcuts/sticky.js";
import "waypoints/lib/shortcuts/infinite.js";


//import "vanilla-cookieconsent";

//import { setupCookieConsent } from './consent';

//import Globe from 'globe.gl';
//import counterUp from 'counterup2'


declare global {
    interface JQuery {
        waypoint(handler: (this: Waypoint, direction?: string) => void, options?: WaypointOptionsJQuery): JQuery;
        waypoint(options?: WaypointOptionsJQuery): JQuery;
    }

    interface WaypointOptionsJQuery extends WaypointOptionsBase {
        handler?: ((this: Waypoint, direction?: string) => void) | undefined;
        context?: HTMLElement | string | undefined;
    }

}

type FunctionArgs = any[];

interface PageInfo {
    isFrontPage: boolean;
    isArchive: boolean;
    isHome: boolean;
    isSingle: boolean;
    isCategory: boolean;
    isMobile: boolean;
    baseUrl: string;
    title: string;
    currentUrl: string;
    ajaxUrl: string;
    debug: boolean;
}


interface ParallaxElement extends HTMLElement {
    initialTop?: number;
    initialBottom?: number;
    initialHeight?: number;
}

class PageScript {
    info: PageInfo;

    constructor(info: PageInfo) {
        this.info = info;
    }

    init() {
        //this.setupCookieConsent();
        //setupCookieConsent();
        this.initQuicklink();
        //this.initWaypoints();
        this.setupScrollAnimations();
        this.handleSmartSticky();
        this.handleNoScroll();
        this.handleOffcanvasNavbar();
        this.handleExpandPanels();
        this.handleCollapseNavbar();
        this.handleFullHeightItems();
        this.handleCarouselCaptionAnimation();
        this.handleCarouselSwipe();
        this.handleParallax();
        //this.setupCounterUp();

        if (this.info.debug) {
            this.log("Debug mode");
            $("#viewport-helper").show();
        }

    }

    /*private setupCounterUp() {
        this.log("setupCounterUp");

        // Foreach element with class counter, create a new Waypoint
        const el = $('.counter');
        for (var n = 0; n < el.length; n++) {
            this.log("counter " + n);
            this.setupCounterUpElement(el[n]);
        }
    }

    private setupCounterUpElement(el: any) {
        this.log("setupCounterUpElement");

        // get data-duration and data-delay
        const duration = $(el).data('duration') || 2000
        const delay = $(el).data('delay') || 16

        // Setup new waypoint
        const waypoint = new Waypoint({
            element: el,
            handler: () => {

                this.log("Firing waypoint of counter " + el);

                // Start counter
                counterUp(el, {
                    duration: duration,
                    delay: delay
                });

                // Destroy waypoint
                waypoint.destroy();

            },
            offset: 'bottom-in-view'
        })


    }
*/
    private handleParallax() {

        function throttle(fn: (...args: FunctionArgs) => void, delay: number): (...args: FunctionArgs) => void {
            let isThrottling = false;
            let context: any;
            let args: FunctionArgs;

            function execute() {
                if (isThrottling) {
                    context = this;
                    args = arguments as any;
                } else {
                    fn.apply(this, arguments);
                    isThrottling = true;
                    setTimeout(() => {
                        isThrottling = false;
                        if (args) {
                            execute.apply(context, args);
                            args = context = null;
                        }
                    }, delay);
                }
            }
            return execute;
        }

        let fullScreenElems: ParallaxElement[] = [];

        function onWindowResize(): void {
            if ($('.js-parallaxed-wide').length) {
                fullScreenElems.forEach(e => $(e).css({ height: "100%", position: "relative" }));
                addParallax();
            }
        }

        function addParallaxedStyles(): void {
            const windowWidth = $(window).width();
            if (windowWidth && windowWidth >= 768) {
                const scrollTop = $(window).scrollTop() || 0;
                fullScreenElems.forEach(e => {
                    if (scrollTop >= e.initialTop!) {
                        $(e).css({ position: "fixed", top: 0, width: "100%", height: `${e.initialHeight}px` });
                    }
                    if (scrollTop >= e.initialBottom! || scrollTop < e.initialTop!) {
                        $(e).css({ position: "relative" });
                    }
                });
            }
        }

        const throttledFunction = throttle(addParallaxedStyles, 16);

        function addParallax(): void {
            fullScreenElems = Array.from($('.parallaxed')) as ParallaxElement[];

            if (fullScreenElems.length) {
                const scrollTop = $(window).scrollTop() || 0;
                const windowWidth = $(window).width() || 0;

                fullScreenElems.forEach(e => {
                    const rect = e.getBoundingClientRect();
                    e.initialTop = scrollTop + rect.top;
                    e.initialBottom = scrollTop + rect.bottom;
                    e.initialHeight = rect.height;

                    if (windowWidth < 768) {
                        $(e).css({ position: "relative", height: `${e.initialHeight}` });
                    } else if (scrollTop >= e.initialTop && windowWidth >= 768) {
                        $(e).css({ position: "fixed", top: 0, width: "100%", height: `${e.initialHeight}px` });
                    } else if (scrollTop >= e.initialBottom || scrollTop < e.initialTop) {
                        $(e).css({ position: "relative", height: `${e.initialHeight}` });
                    }
                });

                $(window).off("resize", onWindowResize).on("resize", onWindowResize);

                if (windowWidth < 768) {
                    $(window).off("scroll", throttledFunction);
                } else {
                    $(window).off("scroll", throttledFunction).on("scroll", throttledFunction);
                }
            }
        }

    }

    private handleCarouselSwipe() {

        // Check if devide supports touch events
        if (('ontouchstart' in document.documentElement)) return;

        var $carousel = $('#homepage-slider'); // Replace with your Carousel ID or class
        var isDragging = false;
        var startingPos = 0;
        var endingPos = 0;

        $carousel.on('mousedown', function (e) {
            isDragging = true;
            startingPos = e.pageX;
        });

        $(document).on('mousemove', function (e) {
            if (isDragging) {
                endingPos = e.pageX;
            }
        });

        $(document).on('mouseup', function (e) {
            if (isDragging) {
                isDragging = false;
                var distanceDragged = startingPos - endingPos;
                if (distanceDragged > 50) { // Dragged to left
                    ($carousel as any).carousel('next');
                } else if (distanceDragged < -50) { // Dragged to right
                    ($carousel as any).carousel('prev');
                }
            }
            startingPos = 0;
            endingPos = 0;
        });
    }

    private handleCarouselCaptionAnimation() {
        const carousel = $('#homepage-slider')

        carousel.on('slide.bs.carousel', event => {

            console.log(event);

            // Get the current slide
            const currentSlide = $(event.target).find('.caption-inner');

            console.log(currentSlide);


        })
    }

    private handleFullHeightItems() {

        var that = this;

        function isMobileMenu() {
            let bkpoint = that.getActiveBreakpoint();
            return bkpoint == "xs" || bkpoint == "sm" || bkpoint == "md";
        }

        function setDivHeight() {
            let navbarHeight = $(".navbar").outerHeight();

            let wpadminbar = $("#wpadminbar");
            let adminBarOffset = wpadminbar.length > 0 ? wpadminbar.outerHeight() : 0;

            $('.fullheight').css('min-height', $(window).height() - (isMobileMenu() ? navbarHeight : 0) - adminBarOffset);

            $('.fullheight.first').css('min-height', $(window).height() - navbarHeight - adminBarOffset);
        }

        // Set the height initially
        setDivHeight();

        // Update the height on window resize
        $(window).on('resize', function () {
            setDivHeight();
        });
    }

    openPanel: HTMLElement = null;
    panelOpener: HTMLElement = null;

    private handleExpandPanels() {

        $('*[data-expand-panel]').on('click', item => {
            var panelOpener = item.target;
            var panel = $("#" + $(panelOpener).attr('data-expand-panel'));

            if (this.openPanel != null) {

                if (this.panelOpener == panelOpener) {

                    panel.fadeOut();
                    $(this.panelOpener).removeClass('active');
                    this.openPanel = null;
                    this.panelOpener = null;
                } else {

                    panel.fadeIn();

                    $(this.openPanel).fadeOut();
                    $(this.panelOpener).removeClass('active');

                    this.openPanel = panel[0];
                    this.panelOpener = panelOpener;
                    $(this.panelOpener).addClass('active');


                }
            } else {

                this.openPanel = panel[0];
                this.panelOpener = panelOpener;
                $(this.panelOpener).addClass('active');
                panel.fadeIn();
            }

        });

        let panels = $(".expand-panel");

        // Clicking anywhere in the document
        $(document).on("click", event => {

            // If the click was not inside the panel or the button that toggles the panel
            if (!$(event.target).closest(panels).length && !$(event.target).closest(this.panelOpener).length) {
                // Check if the panel is visible
                if (panels.is(":visible")) {
                    panels.fadeOut();
                    $(this.panelOpener).removeClass('active');
                    this.panelOpener = null;
                    this.openPanel = null;
                }
            }
        });

    }

    private handleCollapseNavbar() {
        // When scrolling down, hide the navbar. When scrolling up, show the navbar
        var prevScrollpos = window.scrollY;

        const bkPoints = ["lg", "xl", "xxl"]

        var adminBar = $("#wpadminbar");
        var adminBarOffset = adminBar.length > 0 ? adminBar.height() : 0;

        window.onscroll = () => {
            let navbarHeight = $(".navbar").outerHeight();
            let currentScrollPos = window.scrollY;
            let bkpoint = this.getActiveBreakpoint();
            if (bkPoints.indexOf(bkpoint) > -1) {
                if (prevScrollpos > currentScrollPos || currentScrollPos < navbarHeight) {
                    $(".navbar").css('top', adminBarOffset);
                } else {
                    if (this.openPanel == null)
                        $(".navbar").css('top', -navbarHeight + adminBarOffset);
                }
            }
            prevScrollpos = currentScrollPos;
        };

    }

    private handleOffcanvasNavbar() {

        $('#navbarSideCollapse').on('click', evt => {
            $('.offcanvas-collapse').toggleClass('open');
            $(evt.target).toggleClass('open');
            // Show or hide #backdrop
            $("#backdrop").fadeToggle();
        });

        // Find all data-bs-dismiss="custom-offcanvas"
        $('[data-bs-dismiss="custom-offcanvas"]').on('click', evt => {
            $('.offcanvas-collapse').removeClass('open');
            $('.navbar-toggler-icon').removeClass('open');
            $('#navbarSideCollapse').removeClass('open');
            $("#backdrop").fadeOut();
        });

        // Clicking anywhere in the document
        $(document).on("click", event => {

            let offcanvas = $('.offcanvas-collapse');

            if (offcanvas.hasClass('open')) {

                // If the click was not inside the panel or the button that toggles the panel
                if (!$(event.target).closest('.offcanvas-collapse').length && !$(event.target).closest('#navbarSideCollapse').length) {
                    offcanvas.removeClass('open');
                    $('.navbar-toggler-icon').removeClass('open');
                    $('#navbarSideCollapse').removeClass('open');
                    $("#backdrop").fadeOut();

                }
            }

        });

    }

    private getActiveBreakpoint() {

        if ($("#show-xs").is(":visible")) return "xs";
        if ($("#show-sm").is(":visible")) return "sm";
        if ($("#show-md").is(":visible")) return "md";
        if ($("#show-lg").is(":visible")) return "lg";
        if ($("#show-xl").is(":visible")) return "xl";
        if ($("#show-xxl").is(":visible")) return "xxl";

        return "none";
    }

    private handleSmartSticky() {
        this.log("handleSmartSticky");

        var sticky = $(".smart-sticky");

        if (sticky.length == 0) return;

        for (var n = 0; n < sticky.length; n++) {

            var elem = sticky[n];

            // Get element top position
            var top = $(elem).offset().top;

            // Set element top position
            $(elem).css('top', top + 'px');
            $(elem).css('position', 'sticky');

        }

    }

    private initQuicklink() {
        this.log("initQuicklink")
        quicklink.listen({
            timeout: 1000,
            ignores: [
                /\/api\/?/,
                // Target url contains .php
                (uri, elem) => elem.hasAttribute('href') && elem.getAttribute('href').indexOf('.php') > -1,
                (uri, elem) => elem.hasAttribute('noprefetch')
            ]
        });
    }

    /*private initWaypoints() {
        this.log("initWaypoints");
    }*/

    private log(text: any) {
        if (this.info.debug) {
            if (typeof console !== "undefined" && typeof console.log !== "undefined")
                console.log(text);
        }
    }

    private getParameters(rawNames: any) {

        if (typeof rawNames === 'undefined' || rawNames === null || rawNames === '')
            return null;

        let classNames: string;

        if (typeof rawNames === 'object') {
            if (rawNames.baseVal !== undefined)
                classNames = rawNames.baseVal;
            else if (rawNames.animVal !== undefined)
                classNames = rawNames.animVal;
            else
                return null;
        } else
            classNames = rawNames;

        var classes = classNames.split(/\s+/);

        for (var i = 0; i < classes.length; i++) {

            var cls = classes[i];

            if (startsWith(cls, 'animate-')) {

                var params = cls.split('-');

                if (params.length != 3) {
                    this.log('Found invalid class: ' + cls);
                    continue;
                }

                var offset = params[1] + '%';
                var animationClass = params[2];

                return { offset: offset, animationClass: animationClass, keepOnTrigger: false };
            }
        }

        return null;
    }

    // animate-{percent}-{animationClass}

    private handleWaypoint(ts, parameters) {

        return function () {
            this.log(ts);
            this.log('triggered');
            this.log(ts.element);

            $(ts.element).addClass(parameters.animationClass);

            if (!parameters.keepOnTrigger)
                ts.destroy();
        };
    }

    private setupScrollAnimations() {
        this.log("setupScrollAnimations");

        var elements = $("[class^='animate-'],[class*=' animate-']");

        for (var n = 0; n < elements.length; n++) {

            var elem = elements[n];

            var parameters = this.getParameters(elem.className);
            //log(parameters);

            if (parameters == null) continue;

            $(elem).css('opacity', '0').addClass('animated').waypoint({
                handler: (() => {

                    //var ts = this;
                    var parms = parameters;

                    return function () {
                        $(this.element).addClass(parms.animationClass);

                        if (!parms.keepOnTrigger)
                            this.destroy();
                    };
                })(),
                offset: parameters.offset
            });
        }
    }

    // Aggiunge la classe scrolled quando la pagina è scrollata e no-scroll quando non lo è
    private handleNoScroll() {

        function checkScroll() {
            var scroll = $(window).scrollTop();

            var body = $("body");
            // Siamo al top
            if (scroll == 0) {
                body.addClass('scroll-top');
                body.removeClass('scrolled');
            } else {
                body.removeClass('scroll-top');
                body.addClass('scrolled');
            }
        }

        checkScroll();

        $(window).on('scroll', function (event) {
            checkScroll();
        });
    }

    private getParameterByName(name: string, url: string): string {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    private getScroll() {
        if (window.scrollY != undefined) {
            return { x: scrollX, y: scrollY };
        } else {
            var sx, sy, d = document,
                r = d.documentElement,
                b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return { x: sx, y: sy };
        }
    }

}

$(function () {
    const pageInfo: PageInfo = window["pageInfo"];

    // pageInfo.debug is set to true if the query url contains ?debug
    pageInfo.debug = pageInfo.debug || window.location.href.indexOf('?debug') > -1;

    const pageScript = new PageScript(pageInfo);
    pageScript.init();
});

function startsWith(str: string, prefix: string) {
    return str.indexOf(prefix) === 0;
}